import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, FileText, ArrowRight } from "lucide-react";
import { fr } from "../content/fr";
import { fetchOrder, onboardingStep, BACKEND } from "../lib/api";
import { track } from "../lib/tracking";
import Seo from "../components/Seo";
import Header from "../components/Header";
import Footer from "../components/Footer";

const STEPS = ["cadrage", "comptes", "identite"];

export default function Merci() {
  const [params] = useSearchParams();
  const orderId = params.get("order");
  const [order, setOrder] = useState(null);
  const [showOnboard, setShowOnboard] = useState(false);
  const [step, setStep] = useState(0);
  const [payload, setPayload] = useState({ cadrage: "", comptes: "", identite: "" });
  const [saving, setSaving] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    track("Purchase");
    if (orderId) fetchOrder(orderId).then(setOrder).catch(() => {});
  }, [orderId]);

  const saveStep = async () => {
    const key = STEPS[step];
    setSaving(true);
    try { await onboardingStep(orderId, key, { reponse: payload[key] }); } catch {}
    setSaving(false);
    if (step < STEPS.length - 1) setStep(step + 1); else setDone(true);
  };

  const stepMeta = fr.merci.onboard;

  return (
    <div>
      <Seo routeKey="/pilote" path="/merci/pilote" title="Merci — votre pilote est lancé | VIRALYA" />
      <Header />
      <main className="page">
        <div className="container page-narrow">
          <div className="steps-bar"><div className="step active" /><div className="step active" /><div className="step active" /></div>

          {!showOnboard ? (
            <div className="glass card center" data-testid="merci-card">
              <div className="success-ico"><Check size={36} /></div>
              <h1 className="h2" style={{ marginBottom: "0.75rem" }}>{fr.merci.title}</h1>
              <p className="lead" style={{ marginInline: "auto", marginBottom: "1.25rem" }}>{fr.merci.body}</p>
              {order && (
                <p className="mono muted" style={{ fontSize: "0.85rem" }} data-testid="merci-order">
                  N° de commande : {order.id.slice(0, 8).toUpperCase()}
                </p>
              )}
              {orderId && (
                <a href={`${BACKEND}/api/orders/${orderId}/invoice.pdf`} target="_blank" rel="noreferrer"
                   className="btn btn--ghost" style={{ marginTop: "1rem" }} data-testid="merci-invoice">
                  <FileText size={15} /> Télécharger la facture (PDF)
                </a>
              )}
              <div style={{ marginTop: "1.75rem" }}>
                <button className="btn btn--primary" onClick={() => setShowOnboard(true)} data-testid="merci-onboard-cta">
                  {fr.merci.onboardTitle} <ArrowRight size={16} />
                </button>
              </div>
            </div>
          ) : done ? (
            <div className="glass card center" data-testid="onboard-done">
              <div className="success-ico"><Check size={36} /></div>
              <h1 className="h2" style={{ marginBottom: "0.75rem" }}>Cadrage enregistré</h1>
              <p className="lead" style={{ marginInline: "auto" }}>Notre équipe prépare votre personnage. Objectif : première publication en moins de 72 heures.</p>
              <Link to="/" className="btn btn--ghost" style={{ marginTop: "1.5rem" }} data-testid="merci-home">{fr.merci.home}</Link>
            </div>
          ) : (
            <div className="glass card" data-testid="onboard-wizard">
              <div className="steps-bar" style={{ marginBottom: "1.5rem" }}>
                {STEPS.map((s, i) => <div key={s} className={`step ${i <= step ? "active" : ""}`} />)}
              </div>
              <span className="eyebrow"><span className="sq" />Étape {step + 1} / {STEPS.length}</span>
              <h2 className="h3" style={{ margin: "0.4rem 0 0.3rem" }} data-testid="onboard-step-title">{stepMeta[step].t}</h2>
              <p className="muted" style={{ marginBottom: "1.25rem" }}>{stepMeta[step].d}</p>
              <div className="field full">
                <label>Votre réponse</label>
                <textarea rows={4} value={payload[STEPS[step]]}
                  onChange={(e) => setPayload({ ...payload, [STEPS[step]]: e.target.value })}
                  data-testid="onboard-input" />
              </div>
              <button className="btn btn--primary btn--block" style={{ marginTop: "1.25rem" }} onClick={saveStep} disabled={saving} data-testid="onboard-next">
                {saving ? "Enregistrement…" : step < STEPS.length - 1 ? "Étape suivante" : "Terminer"} <ArrowRight size={16} />
              </button>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </div>
  );
}
